import React from 'react'
import './style.css'
import Aos from "aos";
const IsoServices = () => {

  React.useEffect(() => {
    Aos.init({
      offset: 0,
      once:true,
      duration: 800,
      easing: "ease-in-sine",
      delay: 200,
    });
  });

  // hover:cursor-pointer hover:font-bold hover:bg-secondary hover:duration-500
  return (
    <div className='servicesMain'>
      <div className="services-list">
        
      <div className="services-container hover:cursor-pointer hover:font-bold hover:bg-secondary hover:scale-x-105 hover:duration-300" data-aos="zoom-out">
          <h1 className="heading">ISO 9001</h1>
          <div className="desc">Quality Management</div>
        </div>
        <div className="services-container hover:scale-x-105 hover:duration-300" data-aos="zoom-out">
          <h1 className="heading">ISO 14001</h1>
          <div className="desc">Environmental Management</div>
        </div>

        <div className="services-container" data-aos="zoom-out-left">
          <h1 className="heading">ISO 27001</h1>
          <div className="desc">Information Security Management</div>
        </div>

        <div className="services-container" data-aos="zoom-out-right">
          <h1 className="heading">ISO 10001, 10002</h1>
          <div className="desc">Quality Management - Customer Satisfaction</div>
        </div>

        <div className="services-container" data-aos="zoom-out">
          <h1 className="heading">ISO 45001</h1>
          <div className="desc">Occupational health and saftey</div>
        </div>

        <div className="services-container" data-aos="zoom-out-left">
          <h1 className="heading">ISO 17025</h1>
          <div className="desc">Testing and Calibration Laboratories</div>
        </div>

        <div className="services-container" data-aos="zoom-out-right">
          <h1 className="heading">ISO 41001</h1>
          <div className="desc">Facility Management</div>
        </div>

        <div className="services-container" data-aos="zoom-out">
          <h1 className="heading">ISO 13485</h1>
          <div className="desc">Medical Devices</div>
        </div>

        <div className="services-container" data-aos="zoom-out-left">
          <h1 className="heading">ISO 22301</h1>
          <div className="desc">Business Continuity Management System</div>
        </div>

        <div className="services-container" data-aos="zoom-out-right">
          <h1 className="heading">ISO 20000</h1>
          <div className="desc">Service Management</div>
        </div>

        <div className="services-container" data-aos="zoom-out">
          <h1 className="heading">ISO 27032</h1>
          <div className="desc">Cyber Security Management System</div>
        </div>

        <div className="services-container" data-aos="zoom-out-left">
          <h1 className="heading">ISO 38500</h1>
          <div className="desc">IT Governace System</div>
        </div>

        <div className="services-container" data-aos="zoom-out-right">
          <h1 className="heading">ISO 31000</h1>
          <div className="desc">Risk Management</div>
        </div>

        <div className="services-container" data-aos="zoom-out">
          <h1 className="heading">ISO 27017</h1>
          <div className="desc">Cloud Securtiy</div>
        </div>

        <div className="services-container" data-aos="zoom-out-left">
          <h1 className="heading">ISO 27018</h1>
          <div className="desc">Protection of Personally Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 37301</h1>
          <div className="desc">Compliance Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 56002</h1>
          <div className="desc">Innovation Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 197701-1</h1>
          <div className="desc">IT Asset Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 17100</h1>
          <div className="desc">Translation Services</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 26000</h1>
          <div className="desc">Social Responsibility</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 30401</h1>
          <div className="desc">Knowledge Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 18513</h1>
          <div className="desc">Tourism Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 22000</h1>
          <div className="desc">Food Saftey Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 55001</h1>
          <div className="desc">Asset Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 50001</h1>
          <div className="desc">Energy Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 37001</h1>
          <div className="desc">Anti-bribery Management</div>
        </div>

        <div className="services-container" data-aos="zoom-in-up">
          <h1 className="heading">ISO 30402</h1>
          <div className="desc">HRM - Recuritment Managemnet</div>
        </div>



      </div>
      
    </div>
  )
}

export default IsoServices